module.exports = __webpack_public_path__ + "img/OurTeam_Mobile.55f3fe29.png";